interface Props {
  letter: string;
  size?: "sm" | "md" | "lg";
}

const sizes = {
  sm: "h-8 w-8 text-sm",
  md: "h-12 w-12 text-lg",
  lg: "h-16 w-16 text-2xl",
};

export default function Avatar(props: Props) {
  return (
    <div
      class={`tg-avatar flex shrink-0 items-center justify-center rounded-full font-semibold ${sizes[props.size ?? "md"]}`}
    >
      {(props.letter || "?").toUpperCase()}
    </div>
  );
}
